import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, HashRouter } from "react-router-dom";
import Header from "../components/molecules/Header";
import Login from "./login";
import Sys from "./systemAll";
import PrivateRoute from "../components/privateRoute";
import "../styles/notoSansKR.css";
import TeamList from "./teamList";
import TeamDetail from "./teamDetail";
import UserList from "./userList";
import Home from "./home";
import FileSystem from "./fileSystem";

const App: React.FC = () => {
  // 햄버거 메뉴 상태 관리
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <HashRouter>
      <div className="flex flex-col max-h-screen">
        {/* 헤더 영역 */}
        <div className="sticky top-0 z-10">
          <Header />
        </div>

        {/* 본문 내용 */}
        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Sys />
                </PrivateRoute>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route
              path="/mm"
              element={
                <PrivateRoute>
                  <TeamList />
                </PrivateRoute>
              }
            />
            <Route path="/teamDetail/:teamid" element={<TeamDetail />} />
            <Route
              path="/mmuser"
              element={
                <PrivateRoute>
                  <UserList />
                </PrivateRoute>
              }
            />
            <Route
              path="/sys"
              element={
                <PrivateRoute>
                  <Sys />
                </PrivateRoute>
              }
            />
            <Route
              path="/filesystem"
              element={
                <PrivateRoute>
                  <FileSystem />
                </PrivateRoute>
              }
            />
            <Route
              path="/log"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
          </Routes>
        </main>
      </div>
    </HashRouter>
  );
};

export default App;
